import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash.get';

// import _get from 'lodash.get';
import StoryList from 'components_library/templates/StoryList/StoryListMobileWrapper';
import { TOI_LIVE_DOMAIN } from 'constants';
import AuthorWidget from '../../layouts/AuthorWidget/AuthorWidget';

const integrateAuthorIDInLoadMoreDataURL = (sections = [], authorId) =>
  sections.map(item => {
    const {
      config: {
        section: { footer: { moreData: { baseUrl = '' } = {} } = {} } = {},
      } = {},
    } =
      item || {};
    if (baseUrl) {
      const url = new URL(baseUrl, TOI_LIVE_DOMAIN);
      if (!url.searchParams.has('author_id')) {
        url.searchParams.append('author_id', authorId);
        item.config.section.footer.moreData.baseUrl = url.href;
      }
    }
    return item || [];
  });

const AuthorPage = props => {
  const { id, data = {} } = props;
  const { pageData = {} } = data;
  const finalSections = integrateAuthorIDInLoadMoreDataURL(data.sections, id);

  const renderComponent = (componentData, componentIndex) => {
    switch (componentData.type) {
      case 'story_list': {
        const { dataConfig: { path } = {} } = componentData || {};
        let items;
        if (path) {
          items = _get(data, path);
        } else {
          items = Array.isArray(componentData.data)
            ? componentData.data
            : componentData?.data?.items;
        }
        return (
          <StoryList
            items={items}
            {...componentData}
            isMobile
            shouldNotlazyloadLeadImage={componentIndex === 0}
            location={props.location}
          />
        );
      }

      default:
        return null;
    }
  };

  return (
    <>
      <div className="popupWrapper" />
      <div>
        <AuthorWidget authorData={pageData.author} />
        <div className="wrapperclearfix" data-translate-id="cw">
          {finalSections.map((component, index) =>
            renderComponent(component, index),
          )}
        </div>
      </div>
    </>
  );
};

AuthorPage.propTypes = {
  newsData: PropTypes.shape({
    sections: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  seoData: PropTypes.shape({}),
};

AuthorPage.defaultProps = {
  newsData: {
    sections: [],
  },
  seoData: {},
};

export default AuthorPage;
